import { Stack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DataTable } from '../../components/Table/DataTable';
import dateTransformer from '../../helpers/dateTransformer';
import { formatCurrency } from '../../helpers/formatCurrency';

export interface IUnbilledChargesProps {
  unbilledCharges: Array<{
    quantity: number;
    created_at: string;
    description: string;
    amount: number;
  }>;
  isLoading: boolean;
}

export const UnbilledChargesTable = (props: IUnbilledChargesProps) => {
  const { t } = useTranslation();
  const { unbilledCharges = [], isLoading } = props;
  const columnsCost = useMemo(
    () => [
      {
        Header: t('forms:date.label'),
        accessor: (row: { created_at: string }) => dateTransformer(row.created_at as any),
      },
      {
        Header: t('controlling:description.label'),
        accessor: 'description',
      },
      {
        Header: t('controlling:quantity.label'),
        accessor: 'quantity',
      },
      {
        Header: t('controlling:amount.label'),
        // @ts-ignore
        accessor: (row: { amount: string }) => formatCurrency(row.amount),
      },
    ],
    [t],
  );
  return (
    <Stack direction={['column', 'row']} w={'100%'} py={4}>
      <Stack direction="column" w={'100%'}>
        <DataTable
          data-test-id="cost-table"
          hasFilters={false}
          columns={columnsCost}
          loading={isLoading}
          data={unbilledCharges}
          isMoreThenOnePage={false}
          hasSearchInput={undefined as any}
        />
      </Stack>
    </Stack>
  );
};
